import React, { useState, useEffect, useCallback } from "react";
import { GrCircleQuestion } from "react-icons/gr";
import { FiPlus, FiMinus } from "react-icons/fi";
import CTASection from "../CTASection/CTASection.js";

import "./HeroSection.css";
import { useTranslation } from "react-i18next";

function HeroSection({ setActiveTab }) {
  const { t } = useTranslation();

  // --- LOGIQUE ACCORDÉON ---
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  // --- LOGIQUE MACHINE A ECRIRE ---
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [delta, setDelta] = useState(100);

  const words = t("hero.anim_words", { returnObjects: true });
  const period = 2000;

  const tick = useCallback(() => {
    let i = loopNum % words.length;
    let fullText = words[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(30);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(100);
    }
  }, [isDeleting, loopNum, text, words, period]);

  // --- USE EFFECT ---
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => clearInterval(ticker);
  }, [tick, delta]);

  return (
    <>
      <header className="content-header">
        <div>
          <h1>
            {t("hero.welcome")} <span className="gradient-text">AceFund</span>
          </h1>
          <p className="subtitle">
            {t("hero.subtitle_part1")}{" "}
            <span className="gradient-text">{t("hero.subtitle_part2")}</span>
          </p>
        </div>
      </header>

      {/* SECTION QUESTIONS */}
      <section className="questions-container">
        {/* Question 1 */}
        <div
          className={`question-box ${openQuestion === 1 ? "active" : ""}`}
          onClick={() => toggleQuestion(1)}
        >
          <div className="question-header">
            <div className="left-part">
              <div className="question-icon cyan">
                <GrCircleQuestion />
              </div>
              <h3 className="question1">{t("hero.q1_title")}</h3>
            </div>

            <div className="toggle-icon">
              {openQuestion === 1 ? <FiMinus /> : <FiPlus />}
            </div>
          </div>

          <div className="question-content">
            <div className="inner-content">
              <p>
                {t("hero.q1_text1_start")}{" "}
                <span className="gradient-text">{t("hero.q1_text1_span")}</span>{" "}
                {t("hero.q1_text1_end")}
              </p>
              <p>{t("hero.q1_text2")}</p>
            </div>
          </div>
        </div>

        {/* Question 2 */}
        <div
          className={`question-box ${openQuestion === 2 ? "active" : ""}`}
          onClick={() => toggleQuestion(2)}
        >
          <div className="question-header">
            <div className="left-part">
              <div className="question-icon purple">
                <GrCircleQuestion />
              </div>
              <h3 className="question2">{t("hero.q2_title")}</h3>
            </div>

            <div className="toggle-icon">
              {openQuestion === 2 ? <FiMinus /> : <FiPlus />}
            </div>
          </div>

          <div className="question-content">
            <div className="inner-content">
              <p>{t("hero.q2_text1")}</p>
              <p>{t("hero.q2_text2")}</p>
            </div>
          </div>
        </div>
      </section>
      <CTASection setActiveTab={setActiveTab} />

      {/* HERO ANIMATION */}
      <div className="hero-card">
        <div>
          <div className="hero-text-container">
            <p className="static-text">{t("hero.anim_static")}</p>
            <p className="dynamic-text">
              {text}
              <span className="cursor">|</span>
            </p>
          </div>
          <div>
            <p className="hero-subtext">{t("hero.anim_subtext")}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
